import React, { useState, useEffect } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'

import { fetchMonthLeave } from '../../../services/LeaveService'
import { useNavigate } from 'react-router-dom'
const LeaveCalendarList = () => {
    const [selectedEvent, setSelectedEvent] = useState(null)
    const [events, setEvents] = useState([])

    const navigate = useNavigate() // Initialize navigation
    const fetchLeaveList = async (startDate, endDate) => {
        try {
            console.log('Fetching leave data from:', startDate, 'to', endDate)

            const filter = { startDate, endDate }
            let response = await fetchMonthLeave(filter)
            const dailyRecords = response || []

            const formattedEvents = dailyRecords.map((event) => {
                const startDate = new Date(event.start)
                let endDate = new Date(event.end)
                endDate.setDate(endDate.getDate() + 1)

                return {
                    id: event.id,
                    recordId: event.recordId,
                    title: event.title || 'Leave Request',
                    start: event.start,
                    end: endDate.toISOString().split('T')[0], // 🔹 Convert to YYYY-MM-DD
                    backgroundColor: event.backgroundColor,
                    textColor: event.textColor || '#000000',
                    borderColor: event.borderColor || '#ffffff',
                    extendedProps: event.extendedProps || {}
                }
            })

            console.log('Formatted Events:', formattedEvents)
            setEvents(formattedEvents)
        } catch (error) {
            console.error('❌ Error fetching leave data:', error)
        }
    }

    return (
        <div className="p-6 bg-white rounded-lg shadow-lg w-full mx-auto mt-4">
            <FullCalendar
                plugins={[dayGridPlugin, timeGridPlugin]}
                initialView="dayGridMonth"
                weekends={false}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    right: 'timeGridWeek,timeGridDay,dayGridMonth'
                }}
                events={events}
                eventContent={(eventInfo) => (
                    <div className="text-xs text-black">
                        <b>
                            {eventInfo.event.extendedProps.recordId} - {eventInfo.event.title}
                        </b>
                        <br />
                        <span>
                            👤 ({eventInfo.event.extendedProps.position}) - {eventInfo.event.extendedProps.fullname}
                        </span>
                        <br />
                    </div>
                )}
                datesSet={(info) => {
                    const start = info.startStr.substring(0, 10)
                    const end = info.endStr.substring(0, 10)
                    fetchLeaveList(start, end)
                }}
                eventClick={(info) => {
                    setSelectedEvent(info.event)
                }}
            />

            {selectedEvent &&
                (() => {
                    let endDate = new Date(selectedEvent.extendedProps.endLeave)
                    // endDate.setDate(endDate.getDate() - 1)
                    let formattedEndDate = endDate.toISOString().split('T')[0] // Format as YYYY-MM-DD

                    return (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-96 space-y-2">
                                <h2 className="text-xl font-bold">
                                    {selectedEvent.id} - {selectedEvent.title}
                                </h2>
                                <p>
                                    👤 <b>{selectedEvent.extendedProps.fullname}</b>
                                </p>
                                <p>
                                    📅 From: {selectedEvent.extendedProps.startLeave} - {formattedEndDate}
                                </p>
                                <p>📌 Reason: {selectedEvent.extendedProps.description}</p>
                                <p>📌 Duration: {selectedEvent.extendedProps.duration}</p>
                                <p>
                                    📝 Status: <b>{selectedEvent.extendedProps.status}</b>
                                </p>

                                <div className="flex justify-end space-x-4">
                                    <button
                                        className="bg-blue-500 text-white px-4 py-2 rounded"
                                        onClick={() => navigate(`/leave/${selectedEvent.extendedProps.id}`)}
                                    >
                                        View
                                    </button>
                                    <button
                                        className="bg-red-500 text-white px-4 py-2 rounded"
                                        onClick={() => setSelectedEvent(null)}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                })()}
        </div>
    )
}

export default LeaveCalendarList
